import {
	Blocks,
	CakeSlice,
	Clapperboard,
	Coffee,
	FerrisWheel,
	Footprints,
	Landmark,
	type LucideIcon,
	Luggage,
	MapPinned,
	Palette,
	Sandwich,
	ShoppingBag,
	Sparkles,
	Tent,
	TreePalm,
	Trees,
	UtensilsCrossed,
	Waves,
} from 'lucide-react'
import { IconPlaceholder } from '@components/IconPlaceholder.tsx'
import type { ActivityType } from '@hewey/shared'

// Fallback pool for activities with no type set yet — broad "outing" icons.
const GENERAL: readonly LucideIcon[] = [
	MapPinned,
	Sparkles,
	Tent,
	FerrisWheel,
	Trees,
]

// One on-theme icon per activity type. A single-item pool keeps the icon tied
// to the type (unlike recipes, where the meal type is broad); the tint still
// varies per activity via the seed.
const BY_TYPE: Record<ActivityType, readonly LucideIcon[]> = {
	walk: [Footprints],
	swim: [Waves],
	craft: [Palette],
	baking: [CakeSlice],
	museum: [Landmark],
	cinema: [Clapperboard],
	playground: [Blocks],
	cafe: [Coffee],
	restaurant: [UtensilsCrossed],
	park: [Trees],
	shopping: [ShoppingBag],
	day_out: [MapPinned],
	picnic: [Sandwich],
	beach: [TreePalm],
	attraction: [FerrisWheel],
	holiday: [Luggage],
	other: [Sparkles],
}

type Props = {
	// Activity id — the tint is derived from this, so a given activity always
	// shows the same placeholder.
	seed: string
	// Null until the user picks a type; falls through to the GENERAL pool.
	type?: ActivityType | null | undefined
}

export const ActivityPlaceholder = ({ seed, type }: Props) => (
	<IconPlaceholder seed={seed} pool={(type && BY_TYPE[type]) || GENERAL} />
)
